var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Toolbar'),_c('v-main',{staticClass:"vc-fadeIn"},[_c('v-container',{staticClass:"vc-w-100 main-container primaryLight pa-0",attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }